import { createStore, applyMiddleware } from 'redux'
import { apiMiddleware } from 'redux-api-middleware'
import rootReducer from '../reducers'
import apiAuthMiddleware from '../middleware/auth'

export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(apiAuthMiddleware, apiMiddleware),
  )
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js